var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4656 6.69284L13.3219 4.83659C14.1078 4.12027 15.1395 3.73431 16.2026 3.75892C17.2657 3.78353 18.2784 4.21682 19.0303 4.96874C19.7822 5.72067 20.2155 6.7334 20.2401 7.7965C20.2648 8.85959 19.8788 9.8913 19.1625 10.6772L16.5094 13.321C16.127 13.7048 15.6726 14.0093 15.1723 14.2171C14.6719 14.4249 14.1355 14.5318 13.5937 14.5318C13.052 14.5318 12.5155 14.4249 12.0152 14.2171C11.5149 14.0093 11.0605 13.7048 10.6781 13.321",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5343 17.3058L10.6781 19.1621C9.89215 19.8784 8.86045 20.2643 7.79735 20.2397C6.73426 20.2151 5.72152 19.7818 4.9696 19.0299C4.21767 18.278 3.78439 17.2652 3.75978 16.2021C3.73516 15.1391 4.12112 14.1074 4.83744 13.3214L7.49057 10.6777C7.87294 10.2939 8.32732 9.98935 8.82765 9.78156C9.32799 9.57376 9.86442 9.4668 10.4062 9.4668C10.948 9.4668 11.4844 9.57376 11.9847 9.78156C12.4851 9.98935 12.9394 10.2939 13.3218 10.6777",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.1f8170f701e30c6d249ca0d026481a23.svg";
export { ForwardRef as ReactComponent };